/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { EstimatingSalesTaxRatesTabBusinessService } from '../../resources/estimating-sales-tax-rates-tab-business.service';
import { EstimatingSalesTaxRateDetailsDialogComponent } from './estimating-sales-tax-rate-details-dialog.component';

export const estimatingSalesTaxRateDetailsDialog = createDialogRoute({
  component: EstimatingSalesTaxRateDetailsDialogComponent,
  init: EstimatingSalesTaxRatesTabBusinessService,
});
